import { render, staticRenderFns } from "./AssessmentAI.vue?vue&type=template&id=66280ff6&"
import script from "./AssessmentAI.vue?vue&type=script&lang=js&"
export * from "./AssessmentAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports